import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import Loading from "../../components/common/Loading";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
  },
  loader: {
    width: 50,
    height: 50
  }
}));

const RedirectPage = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.loader}>
        <Loading />
      </div>
    </div>
  );
};

export default RedirectPage;
